import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

import { RootState } from "@lxp-app/store/store";

const ALWAYS_ALLOW_PREFIXES = ["/error"]; // only prefix-based rules so error pages will not be restricted
const ALWAYS_ALLOW_EXACT = ["/"]; // exact matches only like homepage, add more if req

export default function OrgGuardLayout() {
  const location = useLocation();
  const user = useSelector((state: RootState) => state.UserInfoSlice.profile);
  const currentOrg = user.org || "gl-india";
  const currentPath = location.pathname;

  const orgRoutes = useSelector(
    (state: RootState) => state.UserInfoSlice.orgRoutes
  );

  // allow exact matches
  if (ALWAYS_ALLOW_EXACT.includes(currentPath)) {
    return <Outlet />;
  }

  // allow certain prefixes
  if (ALWAYS_ALLOW_PREFIXES.some((p) => currentPath.startsWith(p))) {
    return <Outlet />;
  }

  const allowed = orgRoutes?.[currentOrg] ?? "ALL";
  if (allowed === "ALL") return <Outlet />;

  // check allowed prefixes for restricted orgs
  const isAllowed = (allowed as string[]).some((prefix) =>
    currentPath.startsWith(prefix)
  );

  if (!isAllowed) {
    return (
      <Navigate
        to="/error/forbidden"
        replace
        state={{ hideRecommended: false }}
      />
    );
  }

  return <Outlet />;
}
